<template>
  <div class="card card-default">
    <div class="card-header">
      <h4 class="mb-0">{{heading}}</h4>
    </div>
    <div class="card-body pt-1">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Type</th>
            <th>Address</th>
            <th>Netmask</th>
            <th v-if="editable"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(address,index) in validAddresses" :key="index" :class="{'new-table-row': address.isNew}">
            <td>{{address.family}}</td>
            <td>{{address.address}}</td>
            <td v-if="netmasksV6 && address.family == 'IPV6'">
              <div class="input-group">
                <select class="form-control" v-model="address.shortMask">
                  <option :key="mask" v-for="mask in netmasksV6" :value="mask">/{{mask}}</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-success" @click="$emit('save-sale')" type="button"><i
                      class="fa fa-check"></i></button>
                </div>
              </div>
            </td>
            <td v-else>{{address.shortMask}}</td>
            <td v-if="editable" style="text-align:center" v-allowed:view="['STAFF']">
              <button type="button" class="btn btn-danger" @click="removeAddress(address)">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-group col-auto" v-if="ipv6Reissue && ipv6Count === 1" v-allowed:view="['STAFF']">
        <button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown">
          Re-issue IPv6
        </button>
        <div class="dropdown-menu">
          <a href="javascript:void(0)" @click="reissueIP(48)" class="dropdown-item">/48</a>
          <a href="javascript:void(0)" @click="reissueIP(56)" class="dropdown-item">/56</a>
          <a href="javascript:void(0)" @click="reissueIP(64)" class="dropdown-item">/64</a>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        saleNumber: this.$route.params.saleNumber,
        ipv6Network: {},
      }
    },  
    computed: {
      validAddresses() {
        return this.addresses.filter(address => address);
      },
      ipv6Count() {
        return this.validAddresses.filter(addr => addr.family === "IPV6").length;
      }
    },
    props: {
      heading: {
        type: String,
        required: true
      },
      addresses: {
        type: Array,
        required: true
      },
      editable: {
        type: Boolean,
        required: false
      },
      ipv6Reissue: {
        type: Boolean,
        required: false
      },
      netmasksV6: {
        type: Array,
        required: false
      }
    },
    mounted() {
      
    },
    methods: {
      removeAddress(address) {
        this.$emit('removeAddress', address);
      },
      async reissueIP(mask) {
        if (this.ipv6Count !== 1) return; 

        for (let i = 0; i < this.addresses.length; i++) {
          if (this.addresses[i].family == "IPV6") {
            
            let network = this.deepCopyObject(this.addresses[i]);
            network.shortMask = mask;
            
            this.$http.put(this.$config.aimsAPI + "sales/definition/" + this.saleNumber + "/obj/update", network)
              .then((response) => {
                this.showSuccess("Re-issue Successful")
                this.$emit('get-sale')
              },(error) => {
                console.error(error);
                this.showError("Error Saving IPV6", error);
              })
          }
        }
      }
    }
  }

</script>
